const setSearchState = (object: any) => {
    return {
        type: "SET_SearchState",
        payload: object
    }
}

export default {
    setSearchState
}